module.exports = __webpack_public_path__ + "img/32.d29013e7.png";